import { memo } from 'react';

import { ProductListVirtualPage } from './ProductList.VirtualPage.client';

export const ProductListVirtualPageMemoized = memo(ProductListVirtualPage);
